
import { handleActions } from 'redux-actions'
import { mailSenderInfoAction as action } from 'actions'

const initialState = {
  item: {},
  isFetching: false,
  isSubmitting: false,
  processResult: null,
}

export const mailSenderInfo = handleActions(
  {
    [action.fetchMailSenderInfo]: (state) => ({
      ...state,
      isFetching: true,
    }),
    [action.fetchMailSenderInfoDone]: (state, action) => ({
      ...state,
      isFetching: false,
      item: action.error ? state.item : action.payload,
      processResult: action.error ? action.payload : 'SUCCESS',
    }),
    [action.submitUpdateMailSenderInfo]: (state) => ({
      ...state,
      isSubmitting: true,
    }),
    [action.submitUpdateMailSenderInfoDone]: (state, action) => ({
      ...state,
      isSubmitting: false,
      item: action.error ? state.item : { ...state.item, ...action.payload },
      processResult: action.error ? action.payload : 'SUCCESS',
    }),
    [action.submitUpdateLineSenderInfo]: (state) => ({
      ...state,
      isSubmitting: true,
    }),
    [action.submitUpdateLineSenderInfoDone]: (state, action) => ({
      ...state,
      isSubmitting: false,
      item: action.error ? state.item : { ...state.item, ...action.payload },
      processResult: action.error ? action.payload : 'SUCCESS',
    }), 
  },
  initialState
)
